import { track } from "../track";

export const trackProfileView = () => track({ event: "profile_view" });
